import React, { useEffect, useState, Fragment, memo } from 'react';
import { ArrowRight, MicIcon, SettingsIcon } from 'lucide-react';
interface HeroSectionProps {
  setIsFormOpen: (isOpen: boolean) => void;
}
export const HeroSection = ({
  setIsFormOpen
}: HeroSectionProps) => {
  const [currentText, setCurrentText] = useState('');
  const [showResponse, setShowResponse] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const userQuery = 'My laptop is running really slow. Can you help?';
  const aiResponses = ['Analyzing system performance...', "I've identified several potential causes:", '1. High CPU usage from background processes', '2. Low available memory (RAM)', '3. Fragmented hard drive', 'Would you like me to:', 'A) Optimize background processes', 'B) Clear temporary files', 'C) Run disk defragmentation', 'Please type A, B, or C to proceed...'];
  useEffect(() => {
    if (currentStep === 0) {
      let index = 0;
      const timer = setInterval(() => {
        if (index <= userQuery.length) {
          setCurrentText(userQuery.slice(0, index));
          index++;
        } else {
          clearInterval(timer);
          setTimeout(() => {
            setShowResponse(true);
            setCurrentStep(1);
          }, 1000);
        }
      }, 50);
      return () => clearInterval(timer);
    } else if (currentStep <= aiResponses.length) {
      const timer = setTimeout(() => {
        setCurrentStep(prev => prev + 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  }, [currentStep]);
  return <section className="bg-gradient-to-br from-slate-900 to-indigo-900 text-white py-20 px-4" data-id="element-152">
      <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center" data-id="element-153">
        <div className="lg:w-5/12 mb-10 lg:mb-0" data-id="element-154">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-id="element-155">
            Your 24/7 AI Tech Support Agent
          </h1>
          <p className="text-xl md:text-2xl mb-8 text-slate-200" data-id="element-156">
            A fully autonomous AI agent that solves technical issues on Windows
            and Mac OS without human intervention.
          </p>
          <div className="flex flex-col sm:flex-row gap-4" data-id="element-157">
            <button onClick={() => setIsFormOpen(true)} className="bg-white text-indigo-900 px-6 py-3 rounded-lg font-medium hover:bg-slate-100 transition flex items-center justify-center" data-id="element-158">
              Join Waitlist
              <ArrowRight className="ml-2 h-5 w-5" data-id="element-159" />
            </button>
            <a href="#features" className="border border-white text-white px-6 py-3 rounded-lg font-medium hover:bg-white/10 transition text-center" data-id="element-160">
              Learn More
            </a>
          </div>
        </div>
        <div className="lg:w-7/12 lg:pl-10" data-id="element-161">
          <div className="bg-[#1a1b26] rounded-xl overflow-hidden shadow-2xl" data-id="element-162">
            <div className="flex items-center justify-between px-4 py-2 bg-[#1a1b26] border-b border-gray-800" data-id="element-163">
              <span className="text-[#7aa2f7] text-sm font-medium" data-id="element-164">
                TechAIgent v1.0.0
              </span>
              <div className="flex space-x-2" data-id="element-165">
                <div className="w-3 h-3 rounded-full bg-[#f7768e]" data-id="element-166"></div>
                <div className="w-3 h-3 rounded-full bg-[#e0af68]" data-id="element-167"></div>
                <div className="w-3 h-3 rounded-full bg-[#9ece6a]" data-id="element-168"></div>
              </div>
            </div>
            <div className="p-6" data-id="element-169">
              <div className="flex items-center gap-3 mb-6" data-id="element-170">
                <span className="text-[#7aa2f7] text-lg" data-id="element-171">❯</span>
                <div className="flex-1" data-id="element-172">
                  <span className="text-[#7aa2f7]" data-id="element-173">{currentText}</span>
                  {currentStep === 0 && <span className="animate-pulse" data-id="element-174">▊</span>}
                </div>
                <button className="text-[#565f89] hover:text-[#7aa2f7] p-1" data-id="element-175">
                  <MicIcon className="w-6 h-6" data-id="element-176" />
                </button>
                <button className="text-[#565f89] hover:text-[#7aa2f7] p-1" data-id="element-177">
                  <SettingsIcon className="w-6 h-6" data-id="element-178" />
                </button>
              </div>
              {showResponse && <div className="space-y-2 text-[#7aa2f7] mb-6 h-[200px] overflow-y-auto scrollbar-thin scrollbar-thumb-[#565f89] scrollbar-track-transparent" style={{
              scrollBehavior: 'smooth'
            }} ref={el => {
              if (el) {
                el.scrollTop = el.scrollHeight;
              }
            }} data-id="element-179">
                  {aiResponses.slice(0, currentStep - 1).map((response, index) => <div key={index} className="flex items-center gap-3" data-id="element-180">
                        <span className="text-lg" data-id="element-181">❯</span>
                        <span data-id="element-182">{response}</span>
                      </div>)}
                </div>}
              <div className="text-[#565f89] text-sm mt-6 pt-4 border-t border-gray-800 flex justify-between" data-id="element-183">
                <span data-id="element-184">⌘ + ↑↓ to navigate</span>
                <span data-id="element-185">⌘ + Enter to execute</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};